import { render, staticRenderFns } from "./Smtp.vue?vue&type=template&id=85f2ece6"
import script from "./Smtp.vue?vue&type=script&lang=js"
export * from "./Smtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85f2ece6')) {
      api.createRecord('85f2ece6', component.options)
    } else {
      api.reload('85f2ece6', component.options)
    }
    module.hot.accept("./Smtp.vue?vue&type=template&id=85f2ece6", function () {
      api.rerender('85f2ece6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/mailDriver/Smtp.vue"
export default component.exports